class EventObject {
    constructor(jsonData) {      

      const {data, message, status, success, result, error, tokenExpired} = jsonData;

      // console.log('success', success);
      // console.log('result', result);
      // console.log('error', error);
      // console.log('data', data);
      //console.log('message', message);
      //console.log('status', status);
      //console.log('tokenExpired', tokenExpired);

      this.tokenExpired = false

      // Check for token expiration from API response field
      if (tokenExpired === true) {
        this.tokenExpired = true
        // console.log('🔧 EventObject - Token expired detected from API tokenExpired field');
      }

      // Check for token expiration in result.data (legacy method)
      if (result != null){
        if (result.data != null){
          if (result.data.includes('Auth Token expired')) {
            this.tokenExpired = true
            // console.log('🔧 EventObject - Token expired detected from result.data string match');
          } else {
            // Handle other cases here
            //console.log('An error occurred:', result.message);
          }
        }
      }

      // Check for status 60 which indicates invalid auth token
      if (status === '60' || status === 60) {
        this.tokenExpired = true
        // console.log('🔧 EventObject - Token expired detected from status 60');
      }

      // Check for "Invalid Auth Token" in data or message
      if ((data && data.includes('Invalid Auth Token')) || 
          (message && message.includes('Invalid Auth Token'))) {
        this.tokenExpired = true
        // console.log('🔧 EventObject - Token expired detected from Invalid Auth Token message');
      }

      if (error !== undefined) {
        this.success = false
        // Handle error as object or string to avoid [object Object] in alerts
        this.message = typeof error === 'object' && error !== null
          ? (error.message || error.error || JSON.stringify(error))
          : error
      }
      else if (result === undefined && message !== undefined && status !== undefined && status !== 'OK') {
        this.success = false;
        this.message = message;
      }
      else if (result.status !== undefined) {
        this.status = result.status;

        // their naming is misleading, i purposely change it to message
        this.data = result.data;
        this.message = `${result.message} - ${result.data}`;
        this.success = false
      }else {
        this.success = true
        this.result = result
      }            
    }

    isTokenExpired() {
      return this.tokenExpired;
    }
  }
  
  export default EventObject;
  